import React, { Component } from 'react';

// Import custom components
import EmbeddedWebview from '../components/EmbeddedWebview.js';

class FeedbackPage extends Component {
  render() {
    return (
      <div className="FeedbackPage container">
        <EmbeddedWebview src="https://docs.google.com/forms/d/e/1FAIpQLScD0P3EkAi_Km6eMVf5DEj-7ZIZv0hSkYThPjz9zDVepa5VKA/viewform" />
      </div>
    );
  }
}

export default FeedbackPage;



// WEBPACK FOOTER //
// ./src/containers/FeedbackPage.js